import React from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { Text } from '@/components/common/text';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const ChevronRight = RESIDENTS_SVG_COMPONENTS.CHEVRON_RIGHT;

interface PaymentOptionButtonProps {
  label: string;
  onPress: () => void;
  disabled?: boolean;
}

/**
 * Reusable option button with chevron icon
 * Used in AddPaymentMethodContent and ChangePaymentMethodContent
 */
export const PaymentOptionButton: React.FC<PaymentOptionButtonProps> = ({
  label,
  onPress,
  disabled = false,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <TouchableOpacity
      style={[styles.optionButton, { borderColor: MARKETPLACE_COLORS.textPrimary }, disabled && { borderColor: MARKETPLACE_COLORS.inputBorder, opacity: 0.6 }]}
      onPress={onPress}
      activeOpacity={0.8}
      disabled={disabled}
    >
      <Text style={[styles.optionText, { color: MARKETPLACE_COLORS.textPrimary }, disabled && { color: MARKETPLACE_COLORS.textMuted }]} numberOfLines={2}>
        {label}
      </Text>
      <View style={styles.optionRight}>
        {ChevronRight && (
          <ChevronRight
            width={24}
            height={24}
            color={disabled ? MARKETPLACE_COLORS.textMuted : MARKETPLACE_COLORS.textPrimary}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 40,
    paddingVertical: 7, // 40 − 24 chevron slot − 2×1 border, split (the slot is taller than the 21pt line)
    paddingHorizontal: 16,
    borderWidth: 1,
    borderRadius: 8,
  },
  optionText: {
    flex: 1,
    marginRight: 8,
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  optionRight: {
    width: 28,
    height: 24,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});

export default PaymentOptionButton;
